export enum MyCadacCategory {
	Miscellaneous,
	General,
	Software,
	Trainings,
	Experts,
	Support,
	Wallet,
}
